<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM今日订单实时数据 center_9"
      :tooltipText="'实时订单数据'"
    ></chart-title>
    <el-row id="center_9">
      <el-col :lg="6" :md="6" :sm="6" :xs="6">
        <div class="circlr_item">
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text"
              >{{
                getPercentage(
                  orderData.n_convert_figure_num,
                  orderData.convert_figure_num
                )
              }}%</span
            ></dv-decoration-9
          >
          <div class="circlr_item_subtext">
            今日待转图：{{ orderData.n_convert_figure_num }}单
          </div>
          <div class="circlr_item_subtext">
            已转图：{{ orderData.convert_figure_num }}单
          </div>
        </div>
      </el-col>
      <el-col :lg="6" :md="6" :sm="6" :xs="6">
        <div class="circlr_item">
          <div class="circlr_item_subtext">
            今日待审图：{{ orderData.n_drawing_review_completed }}单
          </div>
          <div class="circlr_item_subtext">
            已审图：{{ orderData.drawing_review_completed }}单
          </div>
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text"
              >{{
                getPercentage(
                  orderData.n_drawing_review_completed,
                  orderData.drawing_review_completed
                )
              }}%</span
            ></dv-decoration-9
          >
        </div>
      </el-col>
      <el-col :lg="6" :md="6" :sm="6" :xs="6"
        ><div class="circlr_item">
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text"
              >{{
                getPercentage(orderData.n_invoiced_num, orderData.invoiced_num)
              }}%</span
            ></dv-decoration-9
          >
          <div class="circlr_item_subtext">
            今日待开单：{{ orderData.n_invoiced_num }}单
          </div>
          <div class="circlr_item_subtext">
            已开单：{{ orderData.invoiced_num }}单
          </div>
        </div>
      </el-col>
      <el-col :lg="6" :md="6" :sm="6" :xs="6"
        ><div class="circlr_item">
          <div class="circlr_item_subtext">
            售后中：{{ orderData.n_after_sales_completion_num }}单
          </div>
          <div class="circlr_item_subtext">
            售后完成：{{ orderData.after_sales_completion_num }}单
          </div>
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text"
              >{{
                getPercentage(
                  orderData.n_after_sales_completion_num,
                  orderData.after_sales_completion_num
                )
              }}%</span
            ></dv-decoration-9
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getOrderHandlingData } from "@/api/cockpit/vrhouse";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_9",
  components: { ChartTitle },
  data() {
    return {
      orderData: "",
    };
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      getOrderHandlingData().then((resp) => {
        this.orderData = resp.data.list;
      });
    },
    getPercentage(v1, v2) {
      const nv1 = Number(v1);
      const nv2 = Number(v2);
      if (nv1 + nv2 == 0) {
        return 0;
      } else {
        return ((nv2 / (nv1 + nv2)) * 100).toFixed(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 27vh;
  #center_9 {
    height: calc(100% - 30px);
    padding: 0 24px;
    .circlr_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      .circlr {
        height: 100px;
        width: 100px;
        margin-bottom: 16px;
        .circlr_text {
          color: #dcdfe6;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .circlr_item_subtext {
        color: #ebeef5;
        margin-bottom: 6px;
      }
    }
  }
}
</style>
